import React, { createContext, useState } from 'react';
import { RevampAccordionItemProps } from '../revamp-accordion-item/revamp-accordion-item';

type InitialState = {
  active: string | null;
  setActive: React.Dispatch<React.SetStateAction<string | null>>;
};

const initialState: InitialState = { active: null, setActive: () => {} };
export const AccordionContext = createContext(initialState);

type RevampAccordionProps = {
  children?:
    | React.ReactElement<RevampAccordionItemProps>
    | Array<React.ReactElement<RevampAccordionItemProps>>;
};

const RevampAccordion = ({ children }: RevampAccordionProps) => {
  const [active, setActive] = useState<string | null>(null);

  return (
    <AccordionContext.Provider value={{ active, setActive }}>
      <ul className="flex flex-col gap-y-2">{children}</ul>
    </AccordionContext.Provider>
  );
};

export default RevampAccordion;
